import { render, staticRenderFns } from "./AssociatedData.vue?vue&type=template&id=0397ab91&scoped=true&"
import script from "./AssociatedData.vue?vue&type=script&lang=js&"
export * from "./AssociatedData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397ab91",
  null
  
)

export default component.exports